import React from 'react';
export function Footer() {
  return <footer className="bg-[#1A3C2A] text-white py-12" data-id="element-72">
      <div className="container mx-auto px-4" data-id="element-73">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-74">
          <div data-id="element-75">
            <h3 className="text-xl font-bold mb-4" data-id="element-76">MyoQuell™</h3>
            <p className="mb-4" data-id="element-77">
              Premium herbal knee patches that deliver natural relief where you
              need it most.
            </p>
            <p className="text-sm" data-id="element-78">
              © {new Date().getFullYear()} MyoQuell. All rights reserved.
            </p>
          </div>
          <div data-id="element-79">
            <h3 className="text-lg font-bold mb-4" data-id="element-80">Contact</h3>
            <p className="mb-2" data-id="element-81">Email: support@myoquell.com</p>
            <p data-id="element-82">Hours: Mon-Fri, 9am-5pm EST</p>
          </div>
          <div data-id="element-83">
            <h3 className="text-lg font-bold mb-4" data-id="element-84">Links</h3>
            <ul className="space-y-2" data-id="element-85">
              <li data-id="element-86">
                <a href="#faq" className="hover:underline" data-id="element-87">
                  FAQ
                </a>
              </li>
              <li data-id="element-88">
                <a href="https://myoquell.com/policies/privacy-policy" className="hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-89">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-90">
                <a href="https://myoquell.com/policies/privacy-policy" className="hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-91">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/20 pt-6" data-id="element-92">
          <div className="mb-6" data-id="element-93">
            <h4 className="text-sm font-bold mb-2" data-id="element-94">Payment Methods</h4>
            <div className="flex space-x-4" data-id="element-95">
              <div className="bg-white text-[#1A3C2A] px-2 py-1 rounded text-xs" data-id="element-96">
                VISA
              </div>
              <div className="bg-white text-[#1A3C2A] px-2 py-1 rounded text-xs" data-id="element-97">
                MASTERCARD
              </div>
              <div className="bg-white text-[#1A3C2A] px-2 py-1 rounded text-xs" data-id="element-98">
                AMEX
              </div>
              <div className="bg-white text-[#1A3C2A] px-2 py-1 rounded text-xs" data-id="element-99">
                PAYPAL
              </div>
            </div>
          </div>
          <div className="text-sm" data-id="element-100">
            <p className="font-bold mb-2" data-id="element-101">Disclaimer</p>
            <p className="text-xs leading-relaxed" data-id="element-102">
              Disclaimer (US): The information on this site and the use of our
              herbal knee patches are intended for general wellness and comfort
              only and are not a substitute for professional medical advice,
              diagnosis, or treatment. These statements have not been evaluated
              by the Food and Drug Administration (FDA). This product is not
              intended to diagnose, treat, cure, or prevent any disease. For
              external use only. Do not ingest. Patch test before first use. Do
              not apply to broken, damaged, or irritated skin; avoid contact
              with eyes and mucous membranes. Discontinue use and wash area if
              redness, itching, burning, rash, numbness, or irritation occurs;
              seek medical attention if symptoms persist. Consult your
              healthcare provider before use if you are pregnant or nursing,
              have a medical condition (including skin conditions, circulatory
              issues, neuropathy, or diabetes), or take medications (including
              anticoagulants/blood thinners). Not for children. Individuals with
              known adhesive or botanical sensitivities should use caution. Do
              not use with heating pads or tight bandages. Use only as directed
              and for the recommended wear time. Keep out of reach of children.
              Store in a cool, dry place. Individual results vary; testimonials
              reflect individual experiences and are not typical.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}